import React from "react";

const TestPageContext = React.createContext();

export default TestPageContext;
